import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useMediaQueryContext } from '@fourthwall/components'
import { useOnceInView, useTagManager } from '@hooks'
import { routing } from '@utils/routing'

import { useRecommendationsDismiss } from '../../../Recommendations/hooks/useRecommendationsDismiss'
import type { MiniRecommendationSlideProps } from '../../MiniRecommendations.type'
import * as Carousel from '../../components/Carousel/Carousel'
import { MiniRecommendationDismissButton } from '../../components/MiniRecommendationDismissButton/MiniRecommendationDismissButton'

const ID = 'twitchGifting' as const

const CarouselItem = styled(Carousel.Item)`
  background-color: rgba(130, 84, 255, 0.15);

  &:hover {
    background-color: rgba(130, 84, 255, 0.25);
  }
`

export const TwitchGiftingSlide = ({
  data,
  'data-role': dataRole,
  resetSlider,
}: MiniRecommendationSlideProps) => {
  const navigate = useNavigate()
  const tagManager = useTagManager()
  const { recommendationsDismiss } = useRecommendationsDismiss()
  const { tablet } = useMediaQueryContext()
  const viewRef = useOnceInView(() => {
    tagManager.trigger('mini_recommendation_view', {
      type: ID,
    })
  })

  // Twitch Gifting visibility logic
  const shouldShowTwitchGifting =
    data.twitchGifting?.socialLinks?.socialNetworks?.some(({ name }) => name === 'twitch') &&
    data.twitchGifting?.creatorIntegrations?.twitch?.status !== 'CONNECTED'

  if (!shouldShowTwitchGifting || !recommendationsDismiss.twitchGifting.visible) {
    return null
  }

  const redirectToTwitchApp = () => {
    tagManager.trigger('mini_recommendation_click', {
      type: ID,
    })
    navigate(routing.apps.twitch)
  }

  return (
    <CarouselItem
      ref={viewRef}
      data-role={dataRole}
      data-analytics={ID}
      onClick={redirectToTwitchApp}
    >
      <Carousel.ContentLeft>
        <Carousel.ItemEmote>🎁</Carousel.ItemEmote>
        {tablet && (
          <Carousel.ItemText>
            Tip: Enable Twitch gifting to let chat gift products on stream
          </Carousel.ItemText>
        )}

        {!tablet && <Carousel.ItemText>Tip: Enable Twitch Gifting</Carousel.ItemText>}
      </Carousel.ContentLeft>

      {recommendationsDismiss.twitchGifting.visible && (
        <MiniRecommendationDismissButton
          onDismiss={() => {
            recommendationsDismiss.twitchGifting.dismiss()
            tagManager.trigger('mini_recommendation_dismiss', {
              type: ID,
            })
            setTimeout(() => {
              resetSlider()
            }, 0)
          }}
        />
      )}
    </CarouselItem>
  )
}
